import Chip, { chipClasses } from '@mui/material/Chip'
import styled from '@mui/material/styles/styled'

export const CardChip = styled(Chip, {
  name: 'CardChip',
  slot: 'Root',
  skipSx: true,
})`
  height: 32px;
  border-color: '#1976D2';
  background: rgba(25, 118, 210, 0.08);

  .${chipClasses.label} {
    line-height: 32px;
    padding-right: 4px;
  }
`
